module.exports = __webpack_public_path__ + "f9f8876fb29beb87200a0b9daeecdbde.svg";